module.exports = __webpack_public_path__ + "static/img/our-people-welcome-hero-lowres.1c78b17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-welcome-hero-lowres.jpg
// module id = Ekca
// module chunks = 0